import { LoyaltyProgramCategory } from '@rd/types';
import { z } from 'zod';
import { loyaltyCurrencyModelSchema } from './loyalty-currency.schema';
import { loyaltyProgramCapabilityModelSchema } from './loyalty-program-capability.schema';
import { rewardsProgramModelSchema } from './reward-program.schema';
import {
  cashTransferRateModelSchema,
  pointsTransferRateModelSchema,
  transferRateTypeSchema,
} from './transfer-rate.schema';

export const loyaltyProgramCategorySchema = z.nativeEnum(
  LoyaltyProgramCategory,
);

export const loyaltyProgramModelSchema = z.object({
  id: z.string(),
  type: z.literal('loyalty_program'),
  attributes: z.object({
    category: loyaltyProgramCategorySchema,
    name: z.string(),
    shortName: z.string(),
    description: z.string().nullable(),
    detailsUrl: z.string().nullable(),
    logoUrl: z.string().nullable(), // need to remove once NN deprecate this from their end
    conditionsUrl: z.string().nullable(),
    processingDelay: z.number(),
    transferConnectIdentifier: z.string(),
    manualVerificationRequired: z.boolean(),
    sortIndex: z.number(),
  }),
  relationships: z.object({
    loyaltyCurrency: z
      .object({
        data: z.object({
          id: z.string(),
          type: z.literal('loyalty_currency'),
        }),
      })
      .optional(),
    capabilities: z.object({
      data: z.array(
        z.object({
          id: z.string(),
          type: z.literal('capability'),
        }),
      ),
    }),
    transferRate: z.object({
      data: z.object({
        id: z.string(),
        type: transferRateTypeSchema,
      }),
    }),
    rewardsProgram: z
      .object({
        data: z
          .object({
            id: z.string(),
            type: z.literal('rewards_program'),
          })
          .nullable(),
      })
      .optional(),
  }),
});

export const loyaltyProgramResponseSchema = z.object({
  data: z.array(loyaltyProgramModelSchema),
  included: z.array(
    z.discriminatedUnion('type', [
      loyaltyCurrencyModelSchema,
      loyaltyProgramCapabilityModelSchema,
      cashTransferRateModelSchema,
      pointsTransferRateModelSchema,
      rewardsProgramModelSchema,
    ]),
  ),
});

export const loyaltyProgramShowResponseSchema = z.object({
  data: loyaltyProgramModelSchema,
  included: z.array(
    z.discriminatedUnion('type', [
      loyaltyCurrencyModelSchema,
      loyaltyProgramCapabilityModelSchema,
      cashTransferRateModelSchema,
      pointsTransferRateModelSchema,
      rewardsProgramModelSchema,
    ]),
  ),
});
